import React from "react"
import { useUI } from "providers/UIProvider"
import useCancellationFee from "hooks/useCancellationFee"

import { Box, Center, Flex } from "@chakra-ui/react"
import { useLocation } from "react-router-dom"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import Input from "components/UI/atoms/Input"
import { CANCELLATION_FEE_TABS } from "types/shared"
import { useSettings } from "providers/SettingsProvider/SettingsProvider"
import { useAppContext } from "providers/AppProvider/AppProvider"

const CancellationFeeForm: React.FC = () => {

  const { T } = useUI()
  const { form: { values, errors, touched, handleSubmit, handleChange, handleBlur } } = useCancellationFee()
  const { cancelCommissionsTabType, changeLaundryCancelCommissionsLoading } = useSettings()
  const { selectedBranches } = useAppContext()
  const { pathname } = useLocation()
  const isPercent = cancelCommissionsTabType === CANCELLATION_FEE_TABS.PERCENT

  return (
    <Box mt="30px">
      <form>
        <Box>
          <Flex mb="30px">
            <Box mr="30px">
              <Input
                id="cancellation-fee-time"
                label={T("cancellation_fee.form.time_label")}
                name="time1"
                placeholder={values.placeholderTime1}
                value={values.time1}
                onChange={handleChange}
                onBlur={handleBlur}
                type="number"
                error={Boolean(errors.time1 && touched.time1)}
                errorMessage={errors.time1}
              />
            </Box>
            <Box>
              <Input
                id="cancellation-fee-amount"
                label={isPercent ? `${T("cancellation_fee.form.amount_percent_label")}` : `${T("cancellation_fee.form.amount_fixed_label")}`}
                name="amount1"
                placeholder={values.placeholderAmount1}
                value={values.amount1}
                onChange={handleChange}
                onBlur={handleBlur}
                type="number"
                error={Boolean(errors.amount1 && touched.amount1)}
                errorMessage={errors.amount1}
              />
            </Box>
          </Flex>
          <Flex mb="30px">
            <Box mr="30px">
              <Input
                id="cancellation-fee-time1"
                label={T("cancellation_fee.form.time_label")}
                name="time2"
                placeholder={values.placeholderTime2}
                value={values.time2}
                onChange={handleChange}
                onBlur={handleBlur}
                type="number"
                error={Boolean(errors.time2 && touched.time2)}
                errorMessage={errors.time2}
              />
            </Box>
            <Box>
              <Input
                id="cancellation-fee-amount1"
                label={isPercent ? `${T("cancellation_fee.form.amount_percent_label")}` : `${T("cancellation_fee.form.amount_fixed_label")}`}
                name="amount2"
                placeholder={values.placeholderAmount2}
                value={values.amount2}
                onChange={handleChange}
                onBlur={handleBlur}
                type="number"
                error={Boolean(errors.amount2 && touched.amount2)}
                errorMessage={errors.amount2}
              />
            </Box>
          </Flex>
          <Flex>
            <Box mr="30px">
              <Input
                id="cancellation-fee-time2"
                label={T("cancellation_fee.form.time_label")}
                name="time3"
                placeholder={values.placeholderTime3}
                value={values.time3}
                onChange={handleChange}
                onBlur={handleBlur}
                type="number"
                error={Boolean(errors.time3 && touched.time3)}
                errorMessage={errors.time3}
              />
            </Box>
            <Box>
              <Input
                id="cancellation-fee-amount2"
                label={isPercent ? `${T("cancellation_fee.form.amount_percent_label")}` : `${T("cancellation_fee.form.amount_fixed_label")}`}
                name="amount3"
                placeholder={values.placeholderAmount3}
                value={values.amount3}
                onChange={handleChange}
                onBlur={handleBlur}
                type="number"
                error={Boolean(errors.amount3 && touched.amount3)}
                errorMessage={errors.amount3}
              />
            </Box>
          </Flex>
        </Box>
        <Center as="footer" mt="85px">
          <Button
            _hover={{ backgroundColor: "#08BA36" }}
            isLoading={changeLaundryCancelCommissionsLoading}
            isDisabled={changeLaundryCancelCommissionsLoading || (selectedBranches.length === 0 && pathname === "/settings/cancellation_fee")}
            text={T("actions.confirm")}
            onClick={handleSubmit}
            variant="success"
            styles={{
              width: "280px",
              height: "80px",
              fontSize: "xxl"
            }}
            leftIcon={
              <Icon
                name="confirm"
                iconStyles={{ width: "30px", height: "30px" }}
              />
            }
          />
        </Center>
      </form>
    </Box>
  )
}

export default React.memo(CancellationFeeForm)